import React from 'react';

type MetricItem = {
  key: string;
  label: string;
  value: number;
  color?: string;
  iconBg?: string;
  icon?: React.ReactNode;
};

type SalesCardProps = {
  title: string;
  subtitle?: string;
  top: MetricItem;
  bottomLeft: MetricItem;
  bottomRight: MetricItem;
  className?: string;
};

const CurrencyMXN = (n: number) =>
  n.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const IconBox: React.FC<{ bg?: string; children: React.ReactNode }> = ({
  bg = '#E8F4FF',
  children,
}) => (
  <span
    className="d-inline-flex align-items-center justify-content-center"
    style={{
      width: 32,
      height: 32,
      borderRadius: 8,
      background: bg,
      flexShrink: 0,
    }}
  >
    {children}
  </span>
);

const MetricRow: React.FC<{ item: MetricItem }> = ({ item }) => (
  <div className="d-flex align-items-center">
    <IconBox bg={item.iconBg}>{item.icon}</IconBox>
    <div className="ms-3">
      <div className="fw-bold fs-7" style={{ color: item.color || '#1F2A37' }}>
        {item.label}
      </div>
      <div className="fw-bolder fs-3 text-gray-700">
        {CurrencyMXN(item.value)}
      </div>
    </div>
  </div>
);

const MetricCell: React.FC<{ item: MetricItem; rightBorder?: boolean }> = ({
  item,
  rightBorder,
}) => (
  <div
    className="py-3 px-2"
    style={{
      borderRight: rightBorder ? '1px solid #EEF0F6' : undefined,
    }}
  >
    <div className="d-flex align-items-center">
      <IconBox bg={item.iconBg}>{item.icon}</IconBox>
      <div className="ms-2">
        <div className="fw-bold fs-8" style={{ color: item.color || '#1F2A37' }}>
          {item.label}
        </div>
        <div className="fw-bolder fs-5 text-gray-700">
          {CurrencyMXN(item.value)}
        </div>
      </div>
    </div>
  </div>
);

export const SalesByChannelCard: React.FC<SalesCardProps> = ({
  title,
  subtitle = 'Rendimiento por operación',
  top,
  bottomLeft,
  bottomRight,
  className,
}) => {
  return (
    <div className={`card card-flush h-100 ${className || ''}`}>
      <div className="card-header pt-4 pb-0">
        <div className="card-title d-flex flex-column">
          <span className="fs-4 fw-bolder text-gray-900">{title}</span>
          <span className="text-gray-500 fw-semibold fs-7">{subtitle}</span>
        </div>
      </div>

      <div className="card-body pt-3 pb-3">
        <div className="mb-3">
          <MetricRow item={top} />
        </div>

        <div className="separator mb-3"></div>

        <div className="d-flex flex-wrap">
          <div className="flex-grow-1">
            <MetricCell item={bottomLeft} rightBorder />
          </div>
          <div className="flex-grow-1">
            <MetricCell item={bottomRight} />
          </div>
        </div>
      </div>
    </div>
  );
};
